import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface TableToolbarProps {
  /** Filter inputs on the left side of the toolbar. */
  filters?: ReactNode;
  /** Actions like export, refresh, etc. on the right. */
  actions?: ReactNode;
  /** Result count label, shown leftmost. */
  count?: ReactNode;
  className?: string;
}

/**
 * Standard table toolbar (pa-jp pattern). Lives directly above a table
 * and below the page filter band when both exist.
 */
export const TableToolbar = ({ filters, actions, count, className }: TableToolbarProps) => {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 border-b border-efs-border bg-efs-bg-subtle px-3 py-2',
        className,
      )}
    >
      <div className="flex flex-wrap items-center gap-2 text-xs text-efs-text-muted">
        {count !== undefined ? <span className="font-medium">{count}</span> : null}
        {filters}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
};
